"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } _setPrototypeOf(subClass.prototype, superClass && superClass.prototype); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) { return o.__proto__; }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var disabled = typeof disableReactDisposableDecorator === 'undefined' ? false : disableReactDisposableDecorator;
var inTestingEnv = typeof jasmine !== 'undefined';

function _default(DecoratedComponent) {
  var _class, _temp;

  if (disabled) {
    return DecoratedComponent;
  }

  var originalDisplayName = DecoratedComponent.displayName || DecoratedComponent.name;
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    // Don't change display name in tests, so that snapshots and wrapper.find('CompName') works.
    // But in browser/non-tests react-dev-tools are easier to understand with a slightly altered display name
    function Disposable(props) {
      var _this;

      _classCallCheck(this, Disposable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Disposable).call(this, props));

      _defineProperty(_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelWhenUnmounted", function () {
        for (var _len = arguments.length, thingsToCancel = new Array(_len), _key = 0; _key < _len; _key++) {
          thingsToCancel[_key] = arguments[_key];
        }

        if (thingsToCancel.length === 0) {
          throw new Error("cancelWhenUnmounted should be called with one or more cancelables (an object with a dispose, unsubscribe, or cancel function)");
        }

        thingsToCancel.forEach(function (thingToCancel) {
          if (!thingToCancel || typeof thingToCancel.dispose !== 'function' && typeof thingToCancel.cancel !== 'function' && typeof thingToCancel.unsubscribe !== 'function') {
            throw new Error("cancelWhenUnmounted should be called with one or more cancelables (an object with a dispose, unsubscribe, or cancel function)");
          }

          if (_this.mounted) {
            _this.disposables.push(thingToCancel);
          } else {
            // They called cancelWhenUnmounted after the component unmounted...
            cancel(thingToCancel);
          }
        });
      }), "cancelAllSubscriptions", function () {
        _this.disposables.forEach(function (disposable) {
          cancel(disposable);
        });

        _this.disposables = [];
      });

      _this.disposables = [];
      _this.mounted = true;
      return _this;
    }

    _createClass(Disposable, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(DecoratedComponent, _extends({}, this.props, {
          cancelWhenUnmounted: this.cancelWhenUnmounted,
          cancelAllSubscriptions: this.cancelAllSubscriptions
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cancelAllSubscriptions();
        this.mounted = false;
      }
    }]);

    _inherits(Disposable, _React$Component);

    return Disposable;
  }(_react.default.Component), _defineProperty(_class, "displayName", inTestingEnv ? originalDisplayName : "Cancelable(".concat(originalDisplayName, ")")), _temp;
}

function cancel(thing) {
  if (typeof thing.dispose === 'function') {
    thing.dispose();
  } else if (typeof thing.unsubscribe === 'function') {
    thing.unsubscribe();
  } else if (typeof thing.cancel === 'function') {
    thing.cancel();
  } else {// Don't throw an error when we can't cancel the thing they passed in.
  }
}
//# sourceMappingURL=react-disposable-decorator.js.map